import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePasswordReset = Loadable({
  loader: function loader() {
    return import('../PasswordReset.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePasswordReset;